import { render, staticRenderFns } from "./ConfiguracoesFrete.vue?vue&type=template&id=73e71c15"
import script from "./ConfiguracoesFrete.vue?vue&type=script&lang=js"
export * from "./ConfiguracoesFrete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports